import React, {lazy, Suspense} from 'react';
import styled from 'styled-components';
import {FlatSwitchData} from '../interfaces/SwitchConnectivityState';
import Skeleton from '@material-ui/lab/Skeleton';
import SwitchAccordian from '../components/SwitchAccordian';
import {PortHistoryState} from '../interfaces/PortHistoryState';
import {useSwitchStacksAccordionState} from 'features/SwitchConnectivity/SwitchStack/SwitchStacksAccordionState';

const SwitchTable = lazy(() => import('../SwitchTable/SwitchTable'));

const StyledSkeleton = styled(Skeleton)`
  height: 300px;
  background-color: ${props => props.theme.text}0D;
`;

export default function SwitchTableContainer({
  switchStackName,
  filteredFlattenedSwitchData,
  anchorIDPrefix,
  portHistoryData,
}: {
  switchStackName: string;
  filteredFlattenedSwitchData: FlatSwitchData[];
  anchorIDPrefix: string;
  portHistoryData: PortHistoryState;
}) {
  const {
    state: switchStacksAccordionsState,
    dispatch: reactDispatch,
  } = useSwitchStacksAccordionState();

  const isExpanded = switchStacksAccordionsState.get(switchStackName)!.table;

  const handleAccordianChange = (switchStack: string): void => {
    reactDispatch({
      type: 'TOGGLE_SWITCH_STACK_ACCORDION',
      payload: {switchStack, view: 'table'},
    });
  };

  return (
    <SwitchAccordian
      header={switchStackName}
      anchorId={switchStackName}
      isExpanded={isExpanded}
      key={`${anchorIDPrefix}${switchStackName}`}
      handleAccordianChange={handleAccordianChange}
    >
      <Suspense fallback={<StyledSkeleton />}>
        <SwitchTable
          data={filteredFlattenedSwitchData.filter(
            device => switchStackName === device.switchStackName
          )}
          portHistoryData={portHistoryData.switchStacks[switchStackName]}
          title={switchStackName}
          loaded={true}
          noDataText={"There isn't anything to show here."}
        />
      </Suspense>
    </SwitchAccordian>
  );
}
